import { FoxRequestHeader } from "../../fox-api/domain/fox-request-header";

const ShuttleTripDetailsSearchRequest = function(data) {
  data = data || {};
  this.requestHeader = new FoxRequestHeader({requestType:"GET"});
  this.tripCode = data.tripCode || null;
};
export default ShuttleTripDetailsSearchRequest;
